
export function ShowCaseGameTitle(props)
{
  return (
    <div>
      <h1 className={`title-color-${props.title1Color} text-6xl md:text-8xl xl:text-8xl 2xl:text-9xl font-bolder`}>{props.title1}</h1>
      <h2 className="text-2xl md:text-4xl xl:text-4xl 2xl:text-5xl font-bolder">{props.title2}</h2>
    </div>
  );
}

export function LinkedButton(props)
{
    return (
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        <div className="SteamButton mt-8 md:mt-12 p-6 lg:p-6 xl:p-6 2xl:p-6">
          <h5 className="text-xl xl:text-xl 2xl:text-xl font-bold">{props.text}</h5>
        </div>
      </a>
    )
}

export function PresskitButton(props)
{
    return (
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        <div className="SteamButton mt-6 p-6 lg:p-4">
          <h5 className="text-md font-bold">Presskit</h5>
        </div>
      </a>
    )
}

export function PlushieButton()
{
    const link = "https://www.makeship.com/petitions/umi-plush";

    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className="SteamButton mt-6 p-6 lg:p-4">
          <h5 className="text-md font-bold">Get the Plushie</h5>
        </div>
      </a>
    )
}

export function ShowCaseGameText(prop)
{
  return (
    <div className="flex justify-center xl:justify-normal 2xl:justify-normal">
      <p className="max-w-[18em] lg:max-w-[36em] pt-8 font-extralight
      text-sm md:text-xl lg:text-xl xl:text-base 2xl:text-base">
        {prop.description}
      </p>
    </div>
  )
}

